import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, ViewChild } from '@angular/core';
import { appConfig } from 'src/environments/enviroment';
import { SearchCriteria } from '../models/search-criteria.model';
import * as FileSaver from 'file-saver';
import { ToastComponent } from 'src/app/shared/Toast/toast.component';
@Injectable({
  providedIn: 'root',
})
export class PatientService {
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
  protected apiURL: string = appConfig.apiUrl;

   @ViewChild(ToastComponent) toast: ToastComponent | undefined;

  constructor(public http: HttpClient) { }

  getpaymentConfiguration(practiceId: number) {
    return this.http.get(
      this.apiURL +
      'practice-payment-configuration/get-data-by-practice-id' +
      practiceId,
    );
  }

  getinvoicedetail(patientId?: number) {
    return this.http.get(this.apiURL + 'payment/checkout/' + patientId);
  }
  stripeResponse(stripeRespon: any) {
    
    return this.http.post(
      this.apiURL + 'payment/charge',
      stripeRespon,
      this.httpOptions,
    );
  }
  applePayResponse(stripeRespon: any) {
    return this.http.post(
      this.apiURL + 'payment/charge',
      stripeRespon,
      this.httpOptions,
    );
  }



  getPatientPayment(searchCriteria: SearchCriteria) {
    return this.http.post(
      this.apiURL + 'billing/get-patient-payment',
      searchCriteria,
      this.httpOptions,
    );
  }


  getpatientpayinvoice(patientId: number) {
    return this.http.post(
      this.apiURL + 'payment/get-patient-invoice-data', patientId,
      this.httpOptions,
    );
  }

  getPatientInvoiceCPTs(patientId: number) {
  return this.http.get(
    this.apiURL +  'insurances/patient-invoice-CPTs/' +  patientId,
    this.httpOptions,
  );
  }

  getReceiptDetail(paymentId: string) {
    return this.http.post(
      this.apiURL + 'payment/patient-payment-receipt', paymentId,
      this.httpOptions,
    );
  }

  downloadPatientstatemetZip(patientStatementId) {
    //
    return this.http.post(
      this.apiURL + "patient-statement/download",
      patientStatementId,
      { responseType: "arraybuffer" }
    );
  }

  getPatientstatemetByPatiendID(url) {
    return this.http.get(this.apiURL + url);
  }


// Parent method: returns a Promise that resolves or rejects based on the outcome.
onGenerateStatement(user_id: any): Promise<string> {
  return new Promise((resolve, reject) => {
    const url = 'patient-statement/recent-statementId/' + user_id;
    this.getPatientstatemetByPatiendID(url).subscribe({
      next: (encryptedData: any) => {
        // console.log('Encrypted Data:', encryptedData);

        if (encryptedData) {
          let statementId;
          try {
            statementId = JSON.parse(encryptedData);
          } catch (parseError) {
            console.error('Error parsing statement response:', parseError);
            this.toast?.showToast('No statement has been generated yet.', 'error');
            reject('No statement has been generated yet.');
            return;
          }

          if (statementId) {
            // Call the child function and return its result.
            this.downloadPatientStatementZip(statementId)
              .then((downloadResult: string) => {
                resolve(downloadResult);
              })
              .catch((downloadError: any) => {
                reject(downloadError);
              });
          } else {
            this.toast?.showToast('No statement has been generated yet.', 'info');
            reject('No statement has been generated yet.');
          }
        } else {
          this.toast?.showToast('No statement has been generated yet.', 'info');
          reject('No statement has been generated yet.');
        }
      },
      error: (error) => {
        console.error('Error retrieving statement:', error);
        this.toast?.showToast('No statement has been generated yet.', 'info');
        reject('No statement has been generated yet.');
      }
    });
  });
}

// Child function: returns a Promise that resolves after the file is successfully saved.
downloadPatientStatementZip(statementId: any): Promise<string> {
  return new Promise((resolve, reject) => {
    const payload = {
      patientStatementIds: [statementId],
      fileType: 'pdf'
    };

    this.downloadPatientstatemetZip(payload).subscribe({
      next: (data: any) => {
        if (data) {
          try {
            this.downloaFile(
              data,
              'Patient_Statement_' + this.getCurrentDateTimeString()
            );
            resolve('File downloaded successfully');
          } catch (error) {
            console.error('Error saving file:', error);
            this.toast?.showToast('Error saving file. Please try again later.', 'error');
            reject('Error saving file. Please try again later.');
          }
        } else {
          this.toast?.showToast('Downloaded data is empty.', 'error');
          reject('Downloaded data is empty.');
        }
      },
      error: (error) => {
        console.error('Error downloading file:', error);
        this.toast?.showToast('Unable to retrieve the statement or statement not found.', 'error');
        reject('Unable to retrieve the statement or statement not found.');
      },
      complete: () => {
        // console.log('Completed file download.');
      }
    });
  });
}

// Helper function: returns a formatted date-time string.
getCurrentDateTimeString(): string {
  const now = new Date();
  return (
    now.getFullYear() +
    '-' +
    String(now.getMonth() + 1).padStart(2, '0') +
    '-' +
    String(now.getDate()).padStart(2, '0') +
    '_' +
    String(now.getHours()).padStart(2, '0') +
    '-' +
    String(now.getMinutes()).padStart(2, '0') +
    '-' +
    String(now.getSeconds()).padStart(2, '0') +
    '-' +
    String(now.getMilliseconds()).padStart(3, '0')
  );
}

// Synchronous file download helper.
downloaFile(data: any, name: string) {
  try {
    const file_ext = 'pdf';
    const file_type: string = 'application/pdf'; // MIME type for PDF
    const file = new Blob([data], { type: file_type });
    // console.log('File Blob:', file);
    FileSaver.saveAs(file, name + '.' + file_ext); // Save the file with .pdf extension
  } catch (error) {
    console.error('Error saving file:', error);
    this.toast?.showToast('Error saving file. Please try again later.', 'error');
    // Rethrow the error so that the Promise in downloadPatientStatementZip() can catch it.
    throw error;
  }
}

}
